import React from "react";

const MixmaxIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_451)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.66846 16.6009H4.97054V3.39946H1.66846V16.6009Z",
  fill: "#E55CFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.34884 3.39946L1.66846 16.6009H4.97054L11.6509 3.39946H8.34891H8.34884Z",
  fill: "#24235C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.34888 16.6009H11.651V3.39946H8.34888V16.6009Z",
  fill: "#E55CFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0295 3.39954L8.349 16.601H11.651L18.3315 3.39954H15.0295Z",
  fill: "#24235C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0107 16.6009H18.3128V3.39946H15.0107V16.6009Z",
  fill: "#E55CFF"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_451"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.6666,
  height: 13.202,
  fill: "white",
  transform: "translate(1.66675 3.39901)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MixmaxIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;